/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Col_Case_SummaryInputs */

const en_tasks_col_case_summary = /** @type {(inputs: Tasks_Col_Case_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case summary`)
};

const pt_br2_tasks_col_case_summary = /** @type {(inputs: Tasks_Col_Case_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo do caso`)
};

/**
* | output |
* | --- |
* | "Case summary" |
*
* @param {Tasks_Col_Case_SummaryInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const tasks_col_case_summary = /** @type {((inputs?: Tasks_Col_Case_SummaryInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Col_Case_SummaryInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_col_case_summary(inputs)
	return pt_br2_tasks_col_case_summary(inputs)
});